import React, { useEffect } from 'react'
import { useIntl, navigate } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/press-release-itb2020.png'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'en') {
      navigate('/newsroom/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsITB2020)}
        imageAlt={formatMessage(messages.TitleNewsITB2020)}
        description={formatMessage(metaDescription.NewsITB2020Description)}
        nofollow={locale === 'en'}
        image={Image}
        lang={locale}
      />
      <PressRelease article={newsList.itb2020} />
    </Layout>
  )
}

export default IndexPage
